import React from "react";
import { OFFICE_DESIGNS } from "../../../utils/officeScheme/officeDesignTemplates";

export default function DesignMaster() {
  return (
    <div className="bg-white rounded-2xl shadow p-6">
      <h2 className="text-2xl font-bold text-slate-800">Design Master</h2>
      <p className="text-sm text-slate-500 mb-5">Fixed 3 office model designs.</p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {OFFICE_DESIGNS.map((d) => (
          <div key={d.id} className="border rounded-2xl p-5 bg-slate-50">
            <h3 className="font-bold text-lg">{d.title}</h3>
            <p className="mt-2">Area: {d.area} Sq.ft</p>
            <p>Size: {d.sizeLabel}</p>
            <p className="text-xs text-slate-500 mt-3">
              Actual design PDF district estimate master me link/upload hoga.
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}